import {
	CaptchaApi,
	ChiliPayUserApi,
	ConfigurationApi,
	getHttpClient,
	LoginApi,
	RegistrationApi,
	UserApi
} from '@capsicum/common';

export const chiliPayUserApi = getHttpClient.then(c => new ChiliPayUserApi(c));
export const loginApi = getHttpClient.then(c => new LoginApi(c));
export const captchaApi = getHttpClient.then(c => new CaptchaApi(c));
export const registrationApi = getHttpClient.then(c => new RegistrationApi(c));
export const userApi = getHttpClient.then(c => new UserApi(c));
export const configurationApi = getHttpClient.then(c => new ConfigurationApi(c));
